import CustomMediaViewer from '../../../../../../v2-components/CustomMediaViewer';

export const checkRecipe = (recipe) => {
	const recipeUrl = recipe?.url ? recipe?.url : recipe;
	if (recipe === undefined) {
		return <h3>El usuario no ha adjuntado receta/s para este producto.</h3>;
	}
	return <CustomMediaViewer src={recipeUrl} />
};

